export const weaponNames: Record<string, string> = {
	wname_BarrierGun: "Barrier",
	wname_CannonBurst: "Rajada de canhão",
	wname_Cannon: "Canhão",
	wname_Solidifier: "Solidificador",
	wname_AirBlast: "Rajada de Ar",
	wname_CryoGun: "Arma Criogênica",
	wname_RockGun: "Arma de pedra",
	wname_DebugRemoteControl: "Remote Control",
	wname_DevGunAutoKill: "Auto Kill Bot",
	wname_DrillLauncher: "Broca",
	wname_PlasmaGun: "Plasma",
	wname_Flamethrower: "Lança-Chamas",
	wname_GasBombWeapon: "Bomba de gás",
	wname_LandmineWeapon: "Mina",
	wname_LaserGun: "Laser",
	wname_MissileBurst: "Rajada de mísseis",
	wname_MissileGun: "Míssil",
	wname_OpGun: "Overpowered Gun Mk1",
	wname_OpGun2: "Level clearer",
	wname_OpGunNuke: "Nuke",
	wname_Punch: "Punch",
	wname_TripleSolidifier: "Solidificador Triplo",
	wname_Jetpack: "Mochila-foguete",
	wname_Sword: "Espada",
	wname_Cleaver: "Cutelo",
	wname_BlackHoleGun: "Arma de Buraco Negro",
};
